import { isArray } from 'util';
import { sortByString, mapCollection } from '../../utils/collection.utils';
import { SaleOfferDepartureReason } from '../sale-offer-departure-reason';

export class SaleOfferDepartureReasonBuilder {

  static fromJson(json): SaleOfferDepartureReason {
    return (json) ? new SaleOfferDepartureReason(
      json.hash,
      json.name
    ) : null;
  }

  static fromJsonList(list): SaleOfferDepartureReason[] {
    return (isArray(list)) ? sortByString('name', mapCollection(SaleOfferDepartureReasonBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-departure-reason.builder.ts